// extracted by mini-css-extract-plugin
export default {"bubbles":"Bubbles_bubbles__n9PB6","bubble":"Bubbles_bubble__qKCJ5","animateBubble":"Bubbles_animateBubble__rve6d","sideways":"Bubbles_sideways__05aQq"};